import React from 'react';
import { Link } from 'react-router-dom';
import '../CSS/BlogCard.css';

const BlogCard = ({ post, featured = false }) => {
  return (
    <article className={`blog-card ${featured ? 'blog-card--featured' : ''}`}>
      <div className="blog-card__image-wrap">
        <div className="blog-card__image" style={{ background: post.gradient || 'linear-gradient(135deg, #6366f1 0%, #818cf8 100%)' }}>
          <span className="blog-card__image-icon">{post.icon || '📄'}</span>
        </div>
        {post.isNew && <span className="blog-card__badge">New</span>}
      </div>

      <div className="blog-card__content">
        <div className="blog-card__meta">
          {post.tags?.map((tag) => (
            <span key={tag} className="blog-card__tag">{tag}</span>
          ))}
          <span className="blog-card__date">{post.date}</span>
        </div>

        <h3 className="blog-card__title">
          <Link to={`/blog/${post.slug}`}>{post.title}</Link>
        </h3>

        <p className="blog-card__excerpt">{post.excerpt}</p>

        <div className="blog-card__footer">
          <div className="blog-card__stats">
            <span>🕐 {post.readTime} min read</span>
            {post.views && <span>👁 {post.views} views</span>}
          </div>
          <Link to={`/blog/${post.slug}`} className="blog-card__read-more">
            Read more
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </Link>
        </div>
      </div>
    </article>
  );
};

export default BlogCard;
